<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import DatePicker from 'vue2-datepicker'
    import Multiselect from 'vue-multiselect'

    import * as axios from "axios";

    const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';
    const SITES_API_URL = process.env.VUE_APP_API_URL + 'sites/';
    const USERS_API_URL = process.env.VUE_APP_API_URL + 'users/';

    /**
     * Advanced table component
     */
    export default {
        page: {
            title: 'Commission',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader, Multiselect, DatePicker },
        data() {
            return {
                title: '',
                items: [
                    {
                        text: 'Unblockia',
                        href: '/',
                    },
                    {
                        text: 'Commission',
                        href: '/',
                    },
                ],
                selectedSites: [],
                finalSelectedSites: [],
                selectedPublishers: [],
                selectedMediaBuyer: '',
                allSites: [],
                publisherList: [],
                mediaBuyers: [],
                commissionData: [],
                selectedDate: '',
                loading: false,
                pageOptions: [10, 25, 50, 100],
                perPage: 25,
                filter: null,
                filterOn: [],
                currentPage: 1,
                sortBy: 'domain',
                sortDesc: false,
                month: '',
                year: '',
                fields: [
                    { key: 'no.', stickyColumn: true },
                    { key: 'domain', sortable: true },
                    { key: 'publisher', sortable: true },
                    { key: 'mediaBuyer', sortable: true },
                    { key: 'publisherGross', sortable: true },
                    { key: 'commission' },
                ],
           
            }
        },
        computed: {
            today: function() {
            return new Date()
            },
            publisherGrossTotal: function() {
                if(this.selectedMediaBuyer){
                    return this.commissionData.filter(site => site.mediaBuyer == this.selectedMediaBuyer.name).reduce((a, b) => a + b.publisherGross, 0)
                }
                return ''
                
            },
            commissionMultiplier: function() {
                if(this.selectedMediaBuyer){
                    return this.commissionData.filter(site => site.mediaBuyer == this.selectedMediaBuyer.name).reduce((a, b) => a + Number(b.commission), 0)
                }
                return ''
                
            },
            commissionDataForTable: function() {
                if(this.selectedMediaBuyer){
                    return this.commissionData.filter(site => site.mediaBuyer == this.selectedMediaBuyer.name)
                }
                return this.commissionData
                
            }, 
            rows: function() {
                return this.commissionDataForTable.length
            },
            filteredSiteList: function() {
                if (!this.selectedPublishers.length) {
                    return this.allSites
                } 
                return this.allSites.filter( group => {
                    return this.selectedPublishers.map( x => x.name).includes(group.publisher);
                })
                }
            },
        async mounted() {
            await this.fetchSiteList();
            this.publisherList = this.allSites.filter( x => x.sites.length > 0).map( (y, key) => {return {id: key, name: y.publisher}});

            await this.fetchMediaBuyers();
            this.month = new Date().getMonth()+1;
            this.year = new Date().getFullYear();
            this.selectedDate = new Date(`${this.year}-${this.month}`)
            await this.fetchCommissionData();
            
        },
        methods: {
            async init() {
                this.loading = true;
                if (this.selectedSites.length > 0) {
                    this.finalSelectedSites = this.selectedSites;
                } 
                if (this.selectedPublishers.length > 0 && this.selectedSites.length === 0) {
                    const publisherNames = this.selectedPublishers.map( publisher => publisher.name);
                    let siteList = [];
                    this.allSites.forEach( x => {
                    if (publisherNames.includes(x.publisher)) {
                        siteList = [...siteList, ...x.sites];
                    }
                    })
                    this.finalSelectedSites = siteList;
                }
                await this.fetchCommissionData();
                this.loading = false;
            },
            
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.rows = filteredItems.length;
                this.currentPage = 1
            },
            labelWithPublisher({ domain, publisher }){
                return `${domain} — [${publisher}]`
            },
            async fetchSiteList() {
                const response = await axios(SITES_API_URL + `all/grouped-by-publisher`);
                this.allSites = response.data;
            },
            async fetchMediaBuyers() {
                const fetchUsersResponse = await axios(USERS_API_URL);
                this.mediaBuyers = fetchUsersResponse.data.results.filter(item => ['admin', 'media buyer', 'account manager'].includes(item.role.name)).map(item => ({
                    id: item.id,
                    name: item.name
                }));
            },
            async fetchCommissionData() {
                const selectedSitesIds = this.finalSelectedSites.map(site => (site.id))
                const response = await axios(DASHBOARD_API_URL + `commissions?year=${this.year}&month=${this.month}&sites=${selectedSitesIds}`);
                this.commissionData = response.data;
            },
            changeDate(date) {
                this.month = new Date(date).getMonth()+1;
                this.year = new Date(date).getFullYear();
                this.selectedDate = new Date(`${this.year}-${this.month}`)
            }

        },
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <h4 class="page-title-left">Commission </h4>
                    <div class="page-title-right mt-2">
                        <form class="form-inline mb-2">
                        <div class="form-group flex-form">
                            <div class="input-group input-group-sm mr-2">
                                <multiselect
                                        v-model="selectedPublishers"
                                        :options="publisherList"
                                        :multiple="true"
                                        placeholder="Select publishers"
                                        track-by="id"
                                        label="name"
                                        :closeOnSelect="false"
                                        width="300"
                                        class="commission-select"
                                >
                                </multiselect>
                            </div>
                            <div class="input-group input-group-sm mr-2">
                                <multiselect
                                        v-model="selectedSites"
                                        :options="filteredSiteList"
                                        :multiple="true"
                                        placeholder="Select sites"
                                        track-by="id"
                                        label="domain"
                                        :closeOnSelect="false"
                                        width="300"
                                        group-values="sites"
                                        group-label="publisher"
                                        :group-select="true"
                                        class="commission-select"
                                >
                                
                                </multiselect>
                            </div>
                            <div class="input-group input-group-sm">
                                <date-picker
                                        v-model="selectedDate"
                                        :first-day-of-week="1"
                                        class="border-white home-date-picker"
                                        :not-after="today"
                                        append-to-body
                                        lang="en"
                                        type="month"
                                        :not-before="undefined"
                                        placeholder="Select month"
                                        format="YYYY-MM"
                                        @change="changeDate"
                                >
                                </date-picker>                            
                            </div>
 
                            <a href="javascript: void(0);" class="btn btn-blue btn-sm ml-2" @click="init">
                            <i class="mdi mdi-autorenew"></i>
                            </a>
                        </div>
                        </form>
                    </div>
                    

                </div>  
                <div v-if="loading" class="row justify-content-center" >
                <b-spinner label="Spinning" class="m-2"></b-spinner>
                </div>            
                <div v-else class="card col-12">
                    <div class="card-body">
<!--                         <h4 class="header-title">Commission</h4>
                        <p class="text-muted font-13 mb-4"></p> -->
                        
                        <div class="row mb-md-2">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                           
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-12 d-md-flex align-items-center pt-2 mt-4 bg-light rounded ">
                                
                                <div class="d-flex col-xl-4 col-md-5 col-sm-12 align-items-center mb-2">
                                  <label> Media buyer: </label>
                                  <multiselect
                                    v-model="selectedMediaBuyer"
                                    placeholder="Select a media buyer"
                                    :options="mediaBuyers"
                                    track-by="id"
                                    label="name"
                                    :closeOnSelect="true"
                                    class="col-md-8"
                                    >
                                  </multiselect>
                                </div>
                                <div class="col-xl-8 col-md-7 col-sm-12 d-md-flex flex-row flex-wrap">
                                    <p v-if="selectedMediaBuyer" class="col-lg-4 col-sm-12"> Publisher Gross Total: <strong>{{publisherGrossTotal | currency}}</strong>  </p>
                                    <p v-if="selectedMediaBuyer" class="col-lg-4 col-sm-12"> Commissions: <strong>{{commissionMultiplier}} </strong> </p>
                                </div>

                                
                            </div>

                            
                            
                        </div>

                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    sort-icon-left
                                    :items="commissionDataForTable"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    @filtered="onFiltered"
                            >
                                <template #cell(no.)="data">
                                    <b class="field">{{ (currentPage-1) * perPage + data.index + 1 }}</b>
                                </template>
                                <template #cell(publisherGross)="data">
                                    <b class="field">{{ data.item.publisherGross.toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' }}</b>
                                </template>
                                <template #cell(commission)="data">
                                    <b class="field">{{ data.item.commission? '💰' : '-' }}</b>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style lang="scss">
    .site-select {
      height: 35px !important;
    }
    .home-date-picker {
      width: 240px!important;
    }
    .multiselect__content-wrapper /*, .multiselect__element */ {
      width: 100%!important;
    }
    .commission-select .multiselect__tags {
      max-width: 300px!important;
      min-width: 250px!important;
      height: 37px;
      overflow: scroll !important;
      margin-top: 1.5px;
    }
    ::-webkit-scrollbar
    {
        width:0px;
        height:0px;
    }
    .flex-form{
        display: flex;
        flex-direction: row;
        align-items: flex-start !important;
 
    }

</style>
